module.exports = __webpack_public_path__ + "img/c4.f5b78c49.png";